"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgIcoClientesWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 112 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "100%"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.968 31.24c3.28-2.3 5.452-6.128 5.452-10.442 0-7.058-5.718-12.767-12.787-12.767-7.07 0-12.787 5.709-12.787 12.767 0 4.314 2.15 8.142 5.452 10.443a22.163 22.163 0 00-7.557 4.425 28.682 28.682 0 00-10.371-5.642c4.676-2.832 7.823-7.987 7.823-13.85C72.193 7.235 64.946 0 55.993 0s-16.2 7.257-16.2 16.174a16.155 16.155 0 007.823 13.85 28.921 28.921 0 00-10.26 5.576 22.343 22.343 0 00-7.468-4.337c3.28-2.301 5.451-6.129 5.451-10.443 0-7.058-5.717-12.766-12.786-12.766-7.07 0-12.787 5.708-12.787 12.766 0 4.314 2.15 8.142 5.451 10.443C6.42 34.294.104 42.635.104 52.437v1.46c0 .044.044.089.089.089h27.102a29.711 29.711 0 00-.244 3.739v1.504c0 6.505 5.275 11.771 11.79 11.771H73.19c6.515 0 11.79-5.266 11.79-11.77v-1.505c0-1.261-.09-2.522-.245-3.74h27.28c.045 0 .089-.044.089-.088v-1.46A22.498 22.498 0 0096.968 31.24zM80.392 20.777c0-5.09 4.144-9.227 9.241-9.227 5.097 0 9.241 4.138 9.241 9.227 0 5.022-4.055 9.115-9.064 9.226h-.354a9.22 9.22 0 01-9.064-9.226zm-37.097-4.602c0-6.97 5.673-12.634 12.654-12.634 6.98 0 12.654 5.664 12.654 12.634 0 6.726-5.297 12.235-11.923 12.611h-1.463c-6.626-.376-11.922-5.885-11.922-12.611zm-30.05 4.602c0-5.09 4.144-9.227 9.241-9.227 5.097 0 9.241 4.138 9.241 9.227 0 5.022-4.055 9.115-9.064 9.226h-.354c-5.008-.089-9.064-4.182-9.064-9.226zm14.67 29.647H3.695c.997-9.425 8.975-16.815 18.66-16.881h.265c4.61.022 8.82 1.726 12.078 4.491a29.037 29.037 0 00-6.781 12.39zM81.39 59.23c0 4.536-3.7 8.231-8.244 8.231H38.796c-4.543 0-8.243-3.695-8.243-8.23v-1.505c0-13.74 10.991-24.98 24.664-25.378.244.022.51.022.754.022s.51 0 .753-.022c13.674.398 24.665 11.638 24.665 25.378v1.504zm2.637-8.806a28.96 28.96 0 00-6.714-12.301 18.846 18.846 0 0112.188-4.58h.266c9.684.066 17.662 7.456 18.66 16.881h-24.4z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "02-Clientes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.02-Salir-sin-guardar-cambios",
    transform: "translate(-664 -307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(435 230)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(228.896 77)",
    id: "ico-clientes-warning"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icono/renta"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/gris-tab",
    mask: "url(#mask-2)",
    fill: "#8E8E93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h112v112H0z",
    transform: "translate(.104 -19)",
    id: "Rectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(31.104 40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24.828C0 11.118 11.027 0 24.622 0c13.596 0 24.623 11.119 24.623 24.828S38.218 49.655 24.622 49.655C11.027 49.655 0 38.537 0 24.828z",
    id: "Stroke-8494",
    stroke: "#8E8E93",
    strokeWidth: 4,
    fill: "#FBFBFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.674 41.38c0 1.141-.919 2.068-2.052 2.068a2.061 2.061 0 01-2.051-2.069c0-1.142.919-2.069 2.051-2.069 1.133 0 2.052.927 2.052 2.07",
    id: "Fill-8500",
    fill: "#F2A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.622 33.103V8.276",
    id: "Stroke-8502",
    stroke: "#F2A000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
var _default = exports["default"] = SvgIcoClientesWarning;